import React from "react";
import CartBannerComponent from "../../Components/ProdectBanner/CartBannerComponent";
import "./VendorTerms.css";

const VendorTerms = () => {
  return (
    <div>
      <CartBannerComponent title="Vendor Terms & Conditions" />
      <div className="container vendor-terms-container">
        <div className="row">
          <div className="col-md-12">

            <div className="terms-header">
              <h1>Vendor Terms & Conditions</h1>
              <p className="terms-effective">Effective Date: January 1, 2025</p>
              <p className="terms-intro">
                Please read these terms carefully before registering as a vendor on
                MadeInBangladesh. By completing your vendor registration, you agree
                to be bound by the following terms and conditions.
              </p>
            </div>

            <div className="terms-section">
              <h2>1. Vendor Eligibility</h2>
              <p>
                To register as a vendor on MadeInBangladesh, you must meet the following requirements:
              </p>
              <ul>
                <li>You must be a legally registered business entity in Bangladesh.</li>
                <li>You must hold a valid Trade License or Business Registration Certificate.</li>
                <li>You must have a valid Tax Identification Number (TIN) issued by the National Board of Revenue (NBR).</li>
                <li>You must provide accurate and complete bank account details for payment processing.</li>
                <li>You must be at least 18 years of age.</li>
              </ul>
            </div>

            <div className="terms-section">
              <h2>2. Business Documents</h2>
              <p>
                During registration, vendors are required to submit the following documents:
              </p>
              <ul>
                <li><strong>Business License:</strong> A valid trade license or equivalent business registration document.</li>
                <li><strong>Tax ID (TIN):</strong> Your Tax Identification Number as issued by NBR Bangladesh.</li>
                <li><strong>Bank Details:</strong> Bank name, account number, and account holder name for receiving payments.</li>
                <li><strong>Profile Photo:</strong> A clear photo of the business owner or authorized representative.</li>
              </ul>
              <p>
                MadeInBangladesh reserves the right to verify all submitted documents and reject
                applications that contain false, misleading, or incomplete information.
              </p>
            </div>

            <div className="terms-section">
              <h2>3. Vendor Responsibilities</h2>
              <p>As a registered vendor, you agree to:</p>
              <ul>
                <li>List only authentic products that are manufactured or sourced in Bangladesh.</li>
                <li>Maintain accurate product descriptions, pricing, and stock levels at all times.</li>
                <li>Fulfill orders within the agreed timeframe specified in your shop settings.</li>
                <li>Handle customer complaints and returns in a timely and professional manner.</li>
                <li>Comply with all applicable laws and regulations of Bangladesh.</li>
                <li>Not engage in any fraudulent, deceptive, or misleading practices.</li>
                <li>Keep your business documents and bank details up to date.</li>
              </ul>
            </div>

            <div className="terms-section">
              <h2>4. Prohibited Products</h2>
              <p>The following products are strictly prohibited from being listed on MadeInBangladesh:</p>
              <ul>
                <li>Counterfeit, pirated, or infringing goods.</li>
                <li>Products that violate any applicable law or regulation.</li>
                <li>Hazardous, illegal, or restricted substances.</li>
                <li>Products not manufactured or sourced within Bangladesh.</li>
                <li>Any item that MadeInBangladesh deems inappropriate at its sole discretion.</li>
              </ul>
            </div>

            <div className="terms-section">
              <h2>5. Commissions & Payments</h2>
              <p>
                MadeInBangladesh charges a commission on each sale made through the platform.
                The applicable commission rate will be communicated to you during the onboarding
                process and may be updated with prior notice.
              </p>
              <ul>
                <li>Payments will be disbursed to your registered bank account on a weekly basis.</li>
                <li>MadeInBangladesh reserves the right to withhold payments in case of disputes or policy violations.</li>
                <li>All payment transactions are subject to applicable taxes as per Bangladesh law.</li>
              </ul>
            </div>

            <div className="terms-section">
              <h2>6. Account Suspension & Termination</h2>
              <p>
                MadeInBangladesh reserves the right to suspend or permanently terminate your vendor
                account under the following circumstances:
              </p>
              <ul>
                <li>Submission of false or fraudulent business documents.</li>
                <li>Repeated violations of these terms and conditions.</li>
                <li>Receiving excessive negative reviews or unresolved customer complaints.</li>
                <li>Engaging in activities that harm the reputation of MadeInBangladesh.</li>
                <li>Non-compliance with applicable laws and regulations.</li>
              </ul>
            </div>

            <div className="terms-section">
              <h2>7. Intellectual Property</h2>
              <p>
                By listing products on MadeInBangladesh, you grant us a non-exclusive, royalty-free
                license to use, display, and reproduce your product images and descriptions for the
                purpose of operating and promoting the platform. You represent that you own or have
                the necessary rights to all content you submit.
              </p>
            </div>

            <div className="terms-section">
              <h2>8. Privacy & Data</h2>
              <p>
                Your personal and business information collected during registration will be stored
                securely and used solely for the purpose of operating your vendor account, processing
                payments, and complying with legal obligations. We will not sell or share your data
                with third parties without your consent, except as required by law.
              </p>
            </div>

            <div className="terms-section">
              <h2>9. Amendments</h2>
              <p>
                MadeInBangladesh reserves the right to amend these terms at any time. Vendors will
                be notified of significant changes via email or a prominent notice on the platform.
                Continued use of the platform after such notification constitutes acceptance of the
                updated terms.
              </p>
            </div>

            <div className="terms-section">
              <h2>10. Governing Law</h2>
              <p>
                These terms and conditions are governed by and construed in accordance with the laws
                of the People's Republic of Bangladesh. Any disputes arising under these terms shall
                be subject to the exclusive jurisdiction of the courts of Dhaka, Bangladesh.
              </p>
            </div>

            <div className="terms-contact">
              <h2>Contact Us</h2>
              <p>
                If you have any questions regarding these Vendor Terms & Conditions, please contact
                us at:
              </p>
              <p><strong>Email:</strong> vendor-support@madeinbangladesh.com</p>
              <p><strong>Phone:</strong> +880 1XXX-XXXXXX</p>
              <p><strong>Address:</strong> Dhaka, Bangladesh</p>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default VendorTerms;